import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'secureHtml',
  standalone: true,
})
export class SecureHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  // create this pipe is to resolve the issue that if you use bypassSecurityTrustHtml directly in html it will not allow to copy the text
  transform(content: string) {
    // return this.sanitizer.sanitize(SecurityContext.HTML, content);
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
